<template>
  <v-row
    v-show="isLifetimeAndFeatureActive || !planInfo.isLifetime"
    no-gutters
    class="shadow-card border-radius-small"
    :class="{
      clickable: !isDisabledPlan,
      'card-base-background': !planInfo.isLifetime,
      'card-base-background-lifetime': planInfo.isLifetime && isPreviewOnCheckout,
      'lifetime-card-background': planInfo.isLifetime && $breakpoint.tabletAndUp && !isPreviewOnCheckout,
      'lifetime-card-background-no-selected':
        planInfo.isLifetime && $breakpoint.mobileAndDown && !planInfo.isSelected && !isPreviewOnCheckout,
      'lifetime-card-background-mobile':
        planInfo.isLifetime && !$breakpoint.tabletAndUp && planInfo.isSelected && !isPreviewOnCheckout,
      'not-allowed': isDisabledPlan,
      'lifetime-card-title-border-radius': planInfo.isLifetime && !isPreviewOnCheckout,
      'mb-2': $vuetify.breakpoint.width < 375,
      'mb-4': $vuetify.breakpoint.width >= 375,
      'selected-card': !planInfo.isLifetime && planInfo.isSelected && !isPreviewOnCheckout,
      'selected-card-lifetime': planInfo.isLifetime && planInfo.isSelected && !isPreviewOnCheckout,
    }"
    @click="selectCard"
  >
    <v-col
      v-if="planInfo.isLifetime && !isPreviewOnCheckout"
      class="col-12 text-center lifetime-card-title mb-2"
      :class="{ 'lifetime-card-title-selected': planInfo.isSelected && !isPreviewOnCheckout }"
    >
      <b>{{ planInfo.saveMoneyTitle }}</b>
    </v-col>
    <v-row
      :class="{
        'small-mobile-padding': $vuetify.breakpoint.width < 375,
        'pa-4': $vuetify.breakpoint.width >= 375,
      }"
    >
      <v-col
        class="text-left"
        :class="{
          'col-8': $vuetify.breakpoint.smAndUp && !planInfo.isLifetime,
          'col-12': $vuetify.breakpoint.smAndUp && planInfo.isLifetime,
        }"
      >
        <h4
          v-if="!planInfo.isLifetime"
          class="heading"
          :class="{
            'text--darken-4 ': !isDisabledPlan,
            'text--lighten-1': isDisabledPlan,
            'heading-s-small mb-1': $vuetify.breakpoint.width < 375,
            'heading-m-small mb-2': $vuetify.breakpoint.width >= 375,
            'grey--text': !planInfo.isLifetime,
          }"
        >
          {{ planInfo.title }}
        </h4>
        <v-row
          v-if="planInfo.isLifetime"
          :class="{
            'text--darken-4 ': !isDisabledPlan,
            'text--lighten-1': isDisabledPlan,
          }"
        >
          <v-col
            align="center"
            class="col-4 pt-5"
          >
            <v-row
              align="center"
              :class="{
                'heading-s-small mb-1 pl-2': $vuetify.breakpoint.width < 375,
                'heading-m-small mb-2 pl-3': $vuetify.breakpoint.width >= 375,
              }"
            >
              <span
                class="heading lifetime-text"
                :class="{
                  'white--text': !isPreviewOnCheckout,
                }"
              >
                {{ planInfo.title }}
              </span>
            </v-row>
          </v-col>
          <v-col class="col-8">
            <v-row
              align="center"
              class="lifetime-prices"
            >
              <span
                v-if="!isPreviewOnCheckout"
                class="lifetime-save-money-color"
                >${{ planInfo.saveMoney }}</span
              >
              <div
                class="heading"
                :class="{
                  'white--text': !isPreviewOnCheckout,
                  'primary--text': isPreviewOnCheckout,
                  'heading-m-small': $vuetify.breakpoint.width < 375 && !isPreviewOnCheckout,
                  'heading-l-large': $vuetify.breakpoint.width >= 375 && !isPreviewOnCheckout,
                  'heading-l-small': isPreviewOnCheckout,
                  'mt-1': isPreviewOnCheckout,
                }"
              >
                ${{
                  new Intl.NumberFormat('en-IN', { maximumSignificantDigits: 3 }).format(
                    isLifetimePlan ? planInfo.priceWithDiscount : planInfo.price,
                  )
                }}
              </div>
            </v-row>
          </v-col>
        </v-row>
        <p
          v-if="!planInfo.isPremium"
          class="text text-l-small-regular mb-0 d-flex align-start"
          :class="{
            'text--darken-4': !isDisabledPlan,
            'text--lighten-1': isDisabledPlan,
            'grey--text': !planInfo.isLifetime,
            'white--text': planInfo.isLifetime && !isPreviewOnCheckout,
          }"
        >
          {{
            isPreviewOnCheckout && planInfo.isLifetime
              ? 'Unlimited access to CME and MOC credits.'
              : planInfo.description
          }}
        </p>
        <p
          v-if="planInfo.isPremium"
          class="d-flex align-start text text-l-small-regular text-left mb-0"
          :class="{
            'grey--text text--lighten-1': isDisabledPlan,
          }"
        >
          {{ planInfo.description }}
        </p>
      </v-col>
      <v-col
        v-if="!planInfo.isLifetime"
        class="text-right"
        :class="{
          'col-4': $vuetify.breakpoint.smAndUp,
          'col-auto': !$vuetify.breakpoint.smAndUp,
          'premium-prices': planInfo.isPremium,
        }"
      >
        <strong
          class="heading"
          :class="{
            'primary--text': !isDisabledPlan,
            'grey--text text--lighten-1': isDisabledPlan,
            'heading-m-small': $vuetify.breakpoint.width < 375 && !isPreviewOnCheckout,
            'heading-l-large': $vuetify.breakpoint.width >= 375 && !isPreviewOnCheckout,
            'heading-l-small': isPreviewOnCheckout,
          }"
          >${{ showPerYear ? planInfo.price : planInfo.priceMonthly }}</strong
        >
        <div class="text text-m-small-regular grey--text text--lighten-1">
          {{ textToShowPerCycle }}
        </div>
      </v-col>
      <v-col
        v-if="$vuetify.breakpoint.xsOnly && planInfo.isSelected && !isPreviewOnCheckout"
        cols="12"
        class="mt-0"
      >
        <div
          v-if="planInfo.yearCycle && !planInfo.isLifetime"
          class="chip-billing-cycle text text-l-small-regular mb-4"
        >
          {{ planInfo.yearCycle }} year subscription
        </div>
        <ul class="list-style-none pl-0">
          <li
            v-for="(benefit, index) in planInfo.benefits"
            :key="index"
            class="text text-l-small-regular text--darken-4"
            :class="{
              'mt-4': index > 0,
              'grey--text': !planInfo.isLifetime,
              'white--text': planInfo.isLifetime,
            }"
          >
            <ph-check
              size="24"
              weight="light"
              color="var(--v-secondary-base)"
              class="mr-2"
            />
            <p
              class="mb-0"
              v-html="benefit"
            ></p>
          </li>
          <li
            v-for="(limitation, index) in planInfo.limitations"
            :key="index + uniqueKeysHelper()"
            class="text text-l-small-regular grey--text text--darken-4 mt-4"
          >
            <ph-x
              size="24"
              weight="light"
              color="var(--v-error-base)"
              class="mr-2"
            />
            <p class="mb-0 text-decoration-line-through">{{ limitation }}</p>
          </li>
        </ul>
      </v-col>
    </v-row>
  </v-row>
</template>

<script>
// TODO: deprecated component, we have to remove it

import { v4 as uuidv4 } from 'uuid';
import { PhCheck, PhX } from 'phosphor-vue';
import { featureFlagsMixin, MILESTONE_FREE_AND_LIFETIME_UPDATES_V2_ENABLED } from '@/mixins/featureFlagsMixin';

export default {
  components: { PhCheck, PhX },
  mixins: [
    featureFlagsMixin({
      [MILESTONE_FREE_AND_LIFETIME_UPDATES_V2_ENABLED]: 'milestoneFreeAndLifetimeUpdatesV2Enabled',
    }),
  ],
  props: ['planInfo', 'showPerYear', 'isPreviewOnCheckout'],
  data: () => ({
    uniqueKeysHelper: uuidv4,
  }),
  computed: {
    textToShowPerCycle() {
      if (this.milestoneFreeAndLifetimeUpdatesV2Enabled) {
        if (this.isLifetimePlan) {
          return '';
        } else {
          if (this.showPerYear) {
            return this.planInfo.yearCycle === '1' ? 'per year' : `per ${this.planInfo.yearCycle} years`;
          }
          return 'per month';
        }
      } else {
        if (this.showPerYear) {
          return this.planInfo.yearCycle === '1' ? 'per year' : `per ${this.planInfo.yearCycle} years`;
        }
        return 'per month';
      }
    },
    isLifetimeAndFeatureActive() {
      return this.planInfo.isLifetime;
    },
    isFreePlan() {
      return this.planInfo.title === 'Free Trial';
    },
    isStandardPlan() {
      return this.planInfo.title === 'Standard';
    },
    isProfessionalPlan() {
      return this.planInfo.title === 'Professional';
    },
    isLifetimePlan() {
      return this.planInfo.title === 'Lifetime';
    },
    isPaidPlan() {
      return !this.isFreePlan;
    },
    isDisabledPlan() {
      if (this.$hasToDisablePayments) {
        return this.isPaidPlan;
      }

      return false;
    },
    displayPrice() {
      return this.showPerYear ? this.planInfo.price : this.planInfo.priceMonthly ?? '0';
    },
  },
  mounted() {
    if (this.isLifetimeAndFeatureActive && !this.isPreviewOnCheckout && !this.$route.params.preselectFreeTrial) {
      this.selectCard({ isDefaultInitialSelection: true });
    }

    if (this.isFreePlan && !this.isPreviewOnCheckout && this.$route.params.preselectFreeTrial) {
      this.selectCard({ isDefaultInitialSelection: true });
    }
  },
  methods: {
    selectCard({ isDefaultInitialSelection } = { isDefaultInitialSelection: false }) {
      if (this.$hasToDisablePayments && this.isPaidPlan) {
        return;
      }

      this.$emit('select-card', { selectedPlanInfo: this.planInfo, isDefaultInitialSelection });
    },
  },
};
</script>

<style scoped lang="scss">
.chip-save-money {
  color: white;
  background-color: var(--v-accent-base);
  padding: 4px 8px;
  border-radius: 4px;
  width: fit-content;

  &.disabled {
    background-color: var(--v-grey-lighten1);
  }
}

.lifetime-card-title {
  color: white;
  background-color: var(--v-accent-base);
  padding: 4px 8px;
  width: fit-content;
  font-family: 0.8rem !important;
  border-top-right-radius: 3px;
  border-top-left-radius: 3px;
}

.lifetime-card-title-selected {
  border-top-right-radius: 0px;
  border-top-left-radius: 0px;
}

.lifetime-card-title-border-radius {
  border-radius: 5px 5px 0px 0px;
}

.lifetime-save-money-color {
  color: var(--v-accent-base) !important;
  text-decoration: line-through;
  font-size: 1.2rem;
  margin-right: 12px;
}
.lifetime-card-background {
  background-size: cover !important;
  background: url('~@/assets/subscriptions/LifetimeCardBackground.svg');
}

.lifetime-card-background-no-selected {
  background-size: cover !important;
  background: url('~@/assets/subscriptions/LifetimeCardBackground.svg');
}
.lifetime-card-background-mobile {
  background-size: cover !important;
  background: url('~@/assets/subscriptions/LifetimeCardBackgroundMobile.svg');
}
.lifetime-text {
  font-size: 1.25rem !important;
}
.lifetime-prices {
  justify-content: end;
  padding-right: 16px;
}

.premium-prices {
  padding-top: 12% !important;
}
.chip-billing-cycle {
  color: var(--v-primary-base);
  background-color: var(--v-secondary-surface-base);
  padding: 4px 8px;
  border-radius: 4px;
  width: fit-content;
}
.default-card-state {
  border: 2px solid var(--v-card-base);
}
.small-mobile-padding {
  padding: 16px !important;
}
.selected-card {
  border: 2px solid var(--v-secondary-border-base);
}

li {
  display: flex;
  align-items: flex-start;
}
li svg {
  flex: 0 0 auto;
  width: auto;
  max-width: 100%;
}
li p {
  flex: 1;
  width: auto;
  max-width: 100%;
}

.not-allowed {
  cursor: not-allowed;
}

.circle-icon {
  &.disabled-plan {
    background-color: var(--v-grey-lighten1);
  }
}
</style>
